import { referenceDataEditRules } from '@app/pcs/administration/models';
import { locoTypeDetailed } from '@app/pcs/models';
import { gql } from 'apollo-angular';

export const locoTypesSearchQuery = gql`
  query LocoTypes ($searchContext: LocoTypeSearchInput!) {
    locoType (searchContext: $searchContext) {
      ...locoTypeDetailed
    }
  }
  ${locoTypeDetailed}
`;

export const locoTypesForAgencyQuery = gql`
  query LocoType ($searchContext: LocoTypeSearchInput!, $referenceDataSearchContext: ReferenceDataSearchContextInput, $userGridType: UserGridTypeInput) {
    locoType (searchContext: $searchContext) {
      ...locoTypeDetailed
    }
    referenceDataEditRules (searchContext: $referenceDataSearchContext) {
      ...referenceDataEditRules
    }
    userGridConfiguration (type: $userGridType) {
      configuration
    }
  }
  ${locoTypeDetailed}
  ${referenceDataEditRules}
`;

export const validateLocoTypeNumberQuery = gql`
  query ValidateSeriesNumber ($input: ValidateLocoTypeUniqueInput!) {
    validateSeriesNumber (input: $input)
  }
`;

export const validateNationalIdQuery = gql`
  query ValidateNationalId ($input: ValidateLocoTypeUniqueInput!) {
    validateNationalId (input: $input)
  }
`;

export const locoTypeUsedInDossiersQuery = gql`
  query LocoTypeUsedInDossiers ($id: Long!) {
    locoTypeUsedInDossiers (id: $id)
  }
`;
